export default {
    url: '',
    template: '<user-tasklist-list/>'
};



// WEBPACK FOOTER //
// ./src/app/states/authorized/user/tasklist/list/index.js